import { useDispatch, useSelector } from 'react-redux'
import { toast } from 'react-toastify'
import ValidateUserForm from 'src/components/Form/ValidateUserForm'
import Modal from 'src/components/Modal'
import { selectUserBadge, selectUserBarcode } from 'src/features/selector'
import { actions } from 'src/features/state'
import { sendReceivementBackToQueue } from 'src/services/receivement/receivementService'
import * as S from './BackToQueueModal.styles'
import {
  DarkBlue, DarkBlueHover, DarkRedHover, Red,
} from 'src/assets/colors'
import Button from 'src/components/Button'
import { useCallback } from 'react'

interface BackToQueueModalProps {
  receivement: any
  showModal: any
  setShowModal: any
  setReceivement: any
  getActiveDocks: any
}

const Message = ({ receivementId }: { receivementId: number }) => (
  <S.ModalText>
    Você tem certeza que deseja enviar o recebimento de Nº{receivementId} de volta para fila?
    Todos os dados inseridos no processo de atendimento serão excluídos.
  </S.ModalText>
)

export const BackToQueueModal = ({
  receivement,
  showModal,
  setShowModal,
  setReceivement,
  getActiveDocks,
}: BackToQueueModalProps) => {
  const dispatch = useDispatch()
  const user = useSelector(selectUserBadge)
  const userBarcode = useSelector(selectUserBarcode)

  const cancelBackToQueue = () => {
    setShowModal(false)
    setReceivement(false)
    dispatch(actions.setUserBadge(false))
  }

  const confirmBackToQueue = useCallback(async () => {
    const result = await sendReceivementBackToQueue(
      userBarcode,
      receivement.id_recebimento,
      receivement.status,
    )
    if (!result.isOk) {
      toast.error('Falha ao enviar o recebimento de volta para fila')
      return
    }
    getActiveDocks()
    setShowModal(false)
    setReceivement(false)
    toast.success(`Recebimento ${receivement.id_recebimento} enviado de volta para fila`)
    dispatch(actions.setUserBadge(false))
  }, [
    dispatch,
    getActiveDocks,
    receivement.id_recebimento,
    receivement.status,
    setReceivement,
    setShowModal,
    userBarcode,
  ])

  return (
    <Modal
      show={showModal}
      centered
      closedButton
      title='Retornar recebimento a fila'
      closeButtonAction={cancelBackToQueue}
      body={(
        <S.ModalBody>
          {user
            ? (
              <S.ModalTextContent>
                <Message receivementId={receivement.id_recebimento}/>
              </S.ModalTextContent>
            )
            : (
              <div>
                <ValidateUserForm />
              </div>
            )}
          <S.ModalFooter>
            {user
            && (
            <Button
              text='Confirmar'
              style={{ height: '34px', margin: '10px' }}
              color={DarkBlue}
              hoverColor={DarkBlueHover}
              onClick={confirmBackToQueue}
            />
            )}
            <Button
              text='cancel'
              style={{ height: '34px' }}
              color={Red}
              hoverColor={DarkRedHover}
              onClick={cancelBackToQueue}
            />
          </S.ModalFooter>
        </S.ModalBody>
    )}
    />
  )
}
